import * as yup from 'yup'

const PettyCashAccountsSchem = yup.object().shape({
    userId: yup.string().required('This field is required.'),
    pettyCashAccount: yup.string().trim()
        .matches(/^[a-zA-Z0-9_]+$/, 'Only alphanumeric characters and underscore are allowed.')
        .required('This field is required.'),
    pmBranchId: yup.string().required('This field is required.'),
    pettyCashUsersIds: yup.array().of(yup.string()).min(1, 'This field is required.')
})

export { PettyCashAccountsSchem  };